import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import { Card, CardHeader, Box } from "@mui/material";
import { useChart } from "../chart";

FptsLineupsChart.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  height: PropTypes.number,
};

export default function FptsLineupsChart({
  title,
  subheader,
  chartLabels,
  chartData,
  height = 364,
  ...other
}) {
  const chartOptions = useChart({
    plotOptions: { bar: { columnWidth: "36%" } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    xaxis: {
      categories: chartLabels,
      title: {
        text: "FPTS Range",
      },
    },
    yaxis: {
      title: {
        text: "Number of Lineups",
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== "undefined") {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={chartData}
          options={chartOptions}
          height={height}
        />
      </Box>
    </Card>
  );
}
